export enum REIMBURSEMENTS_FORM_ID {
  Cannabis = 1,
  AlternativeMedicine = 5,
}
